import React from "react";
import types from "./types";

const ArtBoard = ({ variant, size, color, ...props }) => (
  <svg
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {variant === "outline" && (
      <path
        d="M8.586 17H3V15H21V17H15.414L18.657 20.243L17.243 21.657L13 17.414V20H11V17.414L6.757 21.657L5.343 20.243L8.586 17ZM5 3H19C19.2652 3 19.5196 3.10536 19.7071 3.29289C19.8946 3.48043 20 3.73478 20 4V14H4V4C4 3.73478 4.10536 3.48043 4.29289 3.29289C4.48043 3.10536 4.73478 3 5 3ZM6 5V12H18V5H6Z"
        fill={color}
      />
    )}

    {variant === "default" && (
      <path
        d="M8.586 17H3V15H21V17H15.414L18.657 20.243L17.243 21.657L13 17.414V20H11V17.414L6.757 21.657L5.343 20.243L8.586 17ZM5 3H19C19.2652 3 19.5196 3.10536 19.7071 3.29289C19.8946 3.48043 20 3.73478 20 4V14H4V4C4 3.73478 4.10536 3.48043 4.29289 3.29289C4.48043 3.10536 4.73478 3 5 3Z"
        fill={color}
      />
    )}
  </svg>
);

ArtBoard.propTypes = types.propTypes;
ArtBoard.defaultProps = types.defaultProps;

export default ArtBoard;
